import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category/ethical-drama',
    icon: 'ri-tv-2-line',
    title: '韩国伦理剧',
    desc: '涵盖家庭、婚姻、亲情等题材的完整剧集库，支持多维筛选。',
    tone: 'primary',
  },
  {
    to: '/category/popular',
    icon: 'ri-fire-line',
    title: '热门推荐',
    desc: '按播放热度与评分排行，快速锁定近期最受关注的伦理剧。',
    tone: 'accent',
  },
  {
    to: '/special',
    icon: 'ri-bookmark-3-line',
    title: '专题合集',
    desc: '经典家庭伦理、婚姻真相、女性视角等主题化策展合辑。',
    tone: 'secondary',
  },
];

export default function QuickLinks() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
        {entries.map((e, i) => (
          <Link
            key={e.to}
            to={e.to}
            className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors duration-300 hover:border-primary-300 animate-fade-up md:p-6"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <span
              className={`mb-4 flex h-12 w-12 items-center justify-center rounded-md ${
                e.tone === 'primary'
                  ? 'bg-primary-100 text-primary-700'
                  : e.tone === 'accent'
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-700'
              }`}
            >
              <i className={`${e.icon} text-2xl`} />
            </span>
            <h3 className="mb-2 font-heading text-lg font-semibold text-foreground-950">{e.title}</h3>
            <p className="mb-4 flex-1 text-sm leading-relaxed text-foreground-700">{e.desc}</p>
            <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors group-hover:text-accent-600">
              立即进入
              <i className="ri-arrow-right-line text-base" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}